import { render, staticRenderFns } from "./Cerfa.vue?vue&type=template&id=318fb9e4"
import script from "./Cerfa.vue?vue&type=script&lang=js"
export * from "./Cerfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports